import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import api from '../api/api';
import { DISPLAY, Container, formatQ, Search, Truck, WhatsApp, WHATSAPP_DISPLAY } from '../components/home/ui';
import { Card, CardHead, Pill, Steps, Thumb, orderStatus, fecha, orderLabel, pbtn } from '../components/account/shared';

// Rastrea tu pedido (diseño rastrear.html). Se consulta con número **y**
// correo contra `POST /store/orders/track`, sin necesidad de iniciar sesión:
// quien compró como invitado, o no recuerda su contraseña, tiene los dos datos
// en su correo de confirmación y eso alcanza. El backend responde lo mismo
// cuando el número no existe y cuando es de otro correo, así que acá tampoco se
// distinguen los casos.

const Kv = ({ k, v }) => (
    <div className='flex justify-between gap-3 text-[14px] py-[9px] border-b border-[#f1efea] last:border-b-0'>
        <span className='text-[#64748b]'>{k}</span><span className='text-[#0f172a] font-bold text-right'>{v}</span>
    </div>
);

const Rastrear = () => {
    const { userInfo } = useSelector(state => state.auth);
    const [numero, setNumero] = useState('');
    const [correo, setCorreo] = useState(userInfo?.email || '');
    const [error, setError] = useState('');
    const [pedido, setPedido] = useState(null);
    const [buscando, setBuscando] = useState(false);

    const buscar = (e) => {
        e.preventDefault();
        setError('');
        setPedido(null);
        if (!numero.trim() || !/.+@.+\..+/.test(correo)) { setError('Escribe el número de pedido y un correo válido.'); return; }
        setBuscando(true);
        api.post('/orders/track', { numero: numero.trim(), correo: correo.trim() })
            .then(r => setPedido(r.data.order))
            .catch(err => setError(err.response?.data?.detail?.message
                || 'No pudimos consultar el pedido. Intenta de nuevo.'))
            .finally(() => setBuscando(false));
    };

    const st = pedido && orderStatus(pedido.delivery_status);
    const envio = pedido?.shippingInfo || {};
    const prods = pedido?.products || [];

    return (
        <div className='w-full bg-white'>
            <Header />
            <div className='bg-[#faf9f6] pt-8 pb-20 border-t border-[#f1efea]'>
                <Container>
                    <nav className='pb-[14px] text-[13px] text-[#64748b] flex gap-2 items-center' aria-label='Ruta'>
                        <Link to='/' className='hover:text-[#0891b2]'>Inicio</Link><span>/</span><span className='text-[#0f172a] font-semibold'>Rastrea tu pedido</span>
                    </nav>
                    <div className='mb-[22px]'>
                        <h1 className='text-[#1e3a8a] font-bold m-0 tracking-[-.02em] leading-[1.1]' style={{ ...DISPLAY, fontSize: 'clamp(26px, 3vw, 34px)' }}>Rastrea tu pedido</h1>
                        <p className='mt-[6px] mb-0 text-[#64748b] text-[15px] max-w-[620px]'>Escribe tu número de pedido y el correo con el que compraste.</p>
                    </div>

                    <div className='grid grid-cols-[380px_minmax(0,1fr)] md-lg:grid-cols-1 gap-6 items-start'>
                        <div>
                            <Card>
                                <form onSubmit={buscar} noValidate>
                                    {[['tn', 'Número de pedido', numero, setNumero, 'Ej. WEB-2026-00001', 'text', 'Lo encuentras en la confirmación de tu compra y en Mis pedidos.'],
                                      ['te', 'Correo electrónico', correo, setCorreo, 'tu@correo.com', 'email']].map(([id, l, v, set, ph, type, hint]) => (
                                        <div key={id} className='flex flex-col gap-[7px] mb-4'>
                                            <label htmlFor={id} className='text-[13px] font-bold text-[#0f172a]'>{l}</label>
                                            <input id={id} type={type} value={v} onChange={e => set(e.target.value)} placeholder={ph} autoComplete='off'
                                                className='h-12 border-[1.5px] border-[#e8e6e1] rounded-[12px] px-[14px] text-[15px] text-[#0f172a] outline-none focus:border-[#0891b2] focus:shadow-[0_0_0_4px_rgba(8,145,178,.12)]' />
                                            {hint && <span className='text-[12.5px] text-[#64748b]'>{hint}</span>}
                                        </div>
                                    ))}
                                    <button className={`${pbtn} w-full`} disabled={buscando}><Search className='w-[17px] h-[17px]' strokeWidth={2.2} />{buscando ? 'Buscando…' : 'Buscar pedido'}</button>
                                    {error && (
                                        <div role='alert' className='mt-3 px-[14px] py-3 rounded-[12px] bg-[#fef2f2] text-[#b91c1c] text-[13.5px] font-semibold'>
                                            {error}
                                        </div>
                                    )}
                                </form>
                            </Card>
                            <div className='mt-[14px] flex gap-3 items-center p-4 rounded-[16px] bg-[#ecfeff] text-[13.5px] text-[#334155]'>
                                <WhatsApp className='w-[22px] h-[22px] text-[#0891b2] flex-shrink-0' />
                                <div><b className='text-[#0f172a]'>¿Algún problema con tu entrega?</b><br />Escríbenos por WhatsApp al {WHATSAPP_DISPLAY}, de 9:00 a 21:00.</div>
                            </div>
                            <div className='mt-[14px] flex gap-3 items-center p-4 rounded-[16px] bg-white border border-[#f1efea] text-[13.5px] text-[#334155]'>
                                <Truck className='w-[22px] h-[22px] text-[#0891b2] flex-shrink-0' />
                                <div>¿Tienes cuenta? <Link to={userInfo ? '/dashboard/my-orders' : '/login'} className='text-[#0891b2] font-bold'>Ve todos tus pedidos</Link></div>
                            </div>
                        </div>

                        {!pedido ? (
                            <Card className='text-center !py-16'>
                                <div className='w-16 h-16 rounded-full bg-[#ecfeff] text-[#0891b2] grid place-items-center mx-auto mb-[14px]'><Truck className='w-7 h-7' /></div>
                                <h3 className='text-[#1e3a8a] text-[20px] font-bold mt-0 mb-[6px]' style={DISPLAY}>Aquí verás el estado de tu envío</h3>
                                <p className='text-[#64748b] m-0 text-[14.5px]'>Ingresa tu número de pedido para ver en qué va.</p>
                            </Card>
                        ) : (
                            <div>
                                <Card>
                                    <div className='flex justify-between gap-4 flex-wrap items-start mb-[22px]'>
                                        <div>
                                            <span className='text-[12px] text-[#64748b] font-bold tracking-[.06em] uppercase'>Pedido {orderLabel(pedido)}</span>
                                            <h2 className='text-[#1e3a8a] text-[26px] font-bold mt-1 mb-1 tracking-[-.01em]' style={DISPLAY}>{st.headline}</h2>
                                            {pedido.promised_date && st.group === 'proc' && (
                                                <p className='m-0 text-[14px] text-[#334155]'>Entrega estimada: <b className='text-[#0f172a]'>{fecha(pedido.promised_date, { weekday: 'long', day: 'numeric', month: 'long' })}</b></p>
                                            )}
                                        </div>
                                        <Pill kind={st.kind} big>{st.label}</Pill>
                                    </div>
                                    {st.group === 'no'
                                        ? <div className='px-4 py-[14px] bg-[#fef2f2] rounded-[14px] text-[#b91c1c] text-[14px] font-semibold'>Este pedido se canceló.</div>
                                        : <Steps status={pedido.delivery_status} />}
                                </Card>
                                <div className='grid grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] lg:grid-cols-1 gap-[14px] mt-[14px]'>
                                    <Card>
                                        <CardHead title='Productos'><span className='text-[13px] text-[#64748b]'>{prods.length} artículo{prods.length === 1 ? '' : 's'}</span></CardHead>
                                        {prods.map((p, i) => (
                                            <div key={i} className='flex gap-[14px] items-center py-3 border-b border-[#f1efea] last:border-b-0'>
                                                <Thumb src={p.image} />
                                                <div className='flex-1 min-w-0 text-[14px] font-bold text-[#0f172a]'>{p.name}
                                                    <small className='block font-medium text-[#64748b] text-[12.5px] mt-[2px]'>{p.quantity} × {formatQ(p.price)}</small>
                                                </div>
                                            </div>
                                        ))}
                                    </Card>
                                    <Card>
                                        <CardHead title='Datos de entrega' />
                                        {envio.name && <Kv k='Recibe' v={envio.name} />}
                                        {envio.address && <Kv k='Dirección' v={[envio.address, envio.municipality, envio.department].filter(Boolean).join(', ')} />}
                                        {envio.phone && <Kv k='Teléfono' v={envio.phone} />}
                                        <Kv k='Fecha del pedido' v={fecha(pedido.date)} />
                                        <Kv k='Total' v={formatQ(pedido.price)} />
                                        <Link to={`/dashboard/order/details/${pedido._id}`} className='inline-block mt-3 text-[13.5px] font-bold text-[#0891b2]'>Ver el detalle completo →</Link>
                                    </Card>
                                </div>
                            </div>
                        )}
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default Rastrear;
